import { render } from "./AppFileSelect.vue?vue&type=template&id=8bab1576"
import script from "./AppFileSelect.vue?vue&type=script&lang=js"
export * from "./AppFileSelect.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__